import introduction from "./truth_seeker-introduction.json";
import chapter1 from "./truth_seeker-chapter1.json"; // "./truth_seeker-chapter1.json";
import chapter2 from "./truth_seeker-chapter2.json";
import chapter3 from "./truth_seeker-chapter3.json";
import epilogue from "./truth_seeker-epilogue.json";
import headlines from "./headlines.json";
import demographyFinal from "./demographyFinal.json";
import ending from "./truth_seeker-ending.json";

import introduction_m from "./misinformation_introduction.json";
import chapter1_m from "./misinformation_chapter1.json";
import chapter2_m from "./misinformation_chapter2.json";
import chapter_m from "./misinformation_chapter3.json";
import epilogue_m from "./misinformation_epilogue.json";
// import final from "./misinformation_final.json";


export const truthSeeker = [
  { 
    id: "introduction", 
    label_en: "Introduction", 
    label_de: "Einführung", 
    data: introduction,
    style: "default"
  },
  {
    id: "chapter1",
    introductionScreen: "Stirring_Emotions",
    label_en: "Chapter 1: Emotional Triggers",
    label_de: "Kapitel 1: Emotionale Auslöser",
    data: chapter1,
    style: "emotions"
  },
  {
    id: "chapter2",
    introductionScreen: "Trust_Expert",
    label_en: "Chapter 2: Trust me, I’m an expert",
    label_de: "Kapitel 2: Vertrauen Sie mir, ich bin ein Experte",
    data: chapter2,
    style: "expert"
  },
  {
    id: "chapter3",
    introductionScreen: "Connecting_Dots",
    label_en: "Chapter 3: Truth... or Trap?",
    label_de: "Kapitel 3: Wahrheit ... oder Falle?",
    data: chapter3,
    style: "conspiracies"
  },
  {
    id: "epilogue",
    label_en: "Epilogue: Test your new skills",
    label_de: "Epilog: Testen Sie Ihre neuen Fähigkeiten",
    data: epilogue,
    style: "default"
  },
  {
    id: "headlines",
    label_en: "Headlines",
    label_de: "Schlagzeilen",
    data: headlines,
    style: "default"
  },
  {
    id: "demography-final",
    label_en: "Media Survey",
    label_de: "Media Survey",
    data: demographyFinal,
    style: "default"
  },
  {
    id: "ending",
    label_en: "Ending",
    label_de: "Ende",
    data: ending,
    style: "default"
  }
];

export const chaos = [
  { 
    id: "introduction", 
    label_en: "Introduction", 
    label_de: "Einführung", 
    data: introduction_m,
    style: "default"
  },
  {
    id: "chapter1",
    introductionScreen: "Stirring_Emotions",
    label_en: "Chapter 1: Emotional Triggers",
    label_de: "Kapitel 1: Emotionale Auslöser",
    data: chapter1_m,
    style: "emotions"
  },
  {
    id: "chapter2",
    introductionScreen: "Trust_Expert",
    label_en: "Chapter 2: Trust me, I’m an expert",
    label_de: "Kapitel 2: Vertrauen Sie mir, ich bin ein Experte",
    data: chapter2_m,
    style: "expert"
  },
  {
    id: "chapter3",
    introductionScreen: "Connecting_Dots",
    label_en: "Chapter 3: Truth... or Trap?",
    label_de: "Kapitel 3: Wahrheit ... oder Falle?",
    data: chapter_m,
    style: "conspiracies"
  },
  {
    id: "epilogue",
    label_en: "Epilogue: Test your new skills",
    label_de: "Epilog: Testen Sie Ihre neuen Fähigkeiten",
    data: epilogue_m,
    style: "default"
  },
  {
    id: "headlines",
    label_en: "Headlines",
    label_de: "Schlagzeilen",
    data: headlines,
    style: "default"
  },
  {
    id: "demography-final",
    label_en: "Media Survey",
    label_de: "Media Survey",
    data: demographyFinal,
    style: "default"
  },
  {
    id: "ending",
    label_en: "Ending",
    label_de: "Ende",
    data: ending,
    style: "default"
  }
];
